import Link from 'next/link'
import dayjs from 'dayjs'
import classNames from 'classnames'
import styles from './FeaturedArticle.module.scss'
import { FeaturedArticleProps } from './types'
import Author from 'components/author/Author'
import parse from 'html-react-parser'
import { Container, Heading, Img } from '@boltenergy-be/design-system'

const FeaturedArticle = ({ asContentBlock, article }: FeaturedArticleProps) => {
  return (
    <Container fluid={asContentBlock} inset as="section" color="accent-soft" classnames={{ content: styles.wrapper }}>
      <div
        className={classNames(styles['featured-article'], {
          [styles['content-block']]: asContentBlock
        })}
      >
        <Link href={article.destination} className={styles.article}>
          {article.thumbnail && (
            <figure className={styles['thumbnail-wrapper']}>
              <Img
                fill
                priority
                publicId={article.thumbnail.provider_metadata.public_id}
                className={styles.thumbnail}
                style={{ objectFit: 'cover' }}
                alt={`thumbnail - ${article.title}`}
                sizes="(max-width: 620px) 100vw, (max-width: 1120px) 66vw, 50vw"
              />
            </figure>
          )}
          <div className={styles.content}>
            {article.category && (
              <small>
                <strong>{article.category?.title}</strong>
              </small>
            )}
            <Heading as="h2" variant="h3">
              {article.title}
            </Heading>
            <div className={styles.description}>{parse(article.description)}</div>
            <Author
              date={dayjs(article.publishedAt).format('DD/MM/YYYY')}
              name={article.author.firstName}
              imagePublicId={article.author.avatarPublicId}
            />
          </div>
        </Link>
      </div>
    </Container>
  )
}

export default FeaturedArticle
